"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFilterBar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const views_1 = require("./views");
function SortFilterBar({ onFilter, sortProps, }) {
    return (0, jsx_runtime_1.jsx)(views_1.SortFilterBarView, { onFilter: onFilter, sortProps: sortProps });
}
exports.SortFilterBar = SortFilterBar;
